import React, { useState, useEffect } from "react";
import {
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Chip,
} from "@mui/material";
import "./style.scss";
import { isMobileDevice } from "../../../helpers/device-info-helper";

interface Props{
  startYear: number;
  placeholder: string;
  parentClass: string;
  customClass: string;
  onDateSelection: (...args: any[]) => void;
  isMandatory: boolean;
  preSelectedDate: string;
  isCashier?: boolean
}

const DateDropdown = ({ startYear = 1970, placeholder="", parentClass="", customClass="", onDateSelection, isMandatory=false, preSelectedDate="", isCashier = false}: Props) => {
  const [date, setDate] = useState<any>("");
  const [month, setMonth] = useState<any>("");
  const [year, setYear] = useState<any>("");

  useEffect(() => {
    if ( date || month || year ){
      onDateSelection({
        date,
        month,
        year
      });
    }
  }, [date, month, year])

  useEffect(() => {
    if (preSelectedDate) {
      let dateArr = preSelectedDate.split("/"),
          mnthObj:any = monthNames.filter((obj, idx) => {
            if ( dateArr[1] && (obj.value === dateArr[1] || (dateArr[1].length === 1 && Number(obj.value) === Number(dateArr[1]))) ){
              return obj;
            }
          });
      setDate(Number(dateArr[0]));
      setMonth(Number(mnthObj[0]?.value));
      setYear(dateArr[2]);
    }
  }, [preSelectedDate])

  const handleDateChange = (event: any) => {
    setDate(event.target.value);
  };

  const handleMonthChange = (event: any) => {
    setMonth(event.target.value);
  };

  const handleYearChange = (event: any) => {
    setYear(event.target.value);
  };

  const getDaysInMonth = (month: any, year: any) => {
    if (month === 2) {
      return isLeapYear(year) ? 29 : 28;
    } else if ([4, 6, 9, 11].includes(month)) {
      return 30;
    } else {
      return 31;
    }
  };

  const isLeapYear = (year: any) => {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  };

  const monthNames = [
    { value: "01", label: "Jan" },
    { value: "02", label: "Feb" },
    { value: "03", label: "Mar" },
    { value: "04", label: "Apr" },
    { value: "05", label: "May" },
    { value: "06", label: "Jun" },
    { value: "07", label: "Jul" },
    { value: "08", label: "Aug" },
    { value: "09", label: "Sep" },
    { value: "10", label: "Oct" },
    { value: "11", label: "Nov" },
    { value: "12", label: "Dec" },
  ];

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const currentDate = today.getDate();
  const maxDaysInMonth = getDaysInMonth(month, year);

  const isDateValid = (date:any, month:any, year:any) => {
    if (year > currentYear) {
      return false;
    } else if ((year === currentYear && month > currentMonth) || (year === currentYear && month === currentMonth && date > currentDate) ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className={`date-picker-dropdown-cnt ${parentClass}`}>
      <InputLabel className="mb-8 text-14 capitalize text-[#656565]">
        {placeholder}{isMandatory && <span className="text-[#9A3131]"> *</span>}
      </InputLabel>
      <FormControl sx={{ minWidth: 110, height: 52, marginRight: isMobileDevice() ? "10px" : "35px" }}>
        <Select
          value={date}
          onChange={handleDateChange}
          displayEmpty
          className={`${customClass}`}
          disabled = {isCashier}
        >
          <MenuItem value="">
            <p className="text-14 text-[#424243] font-medium">Date</p>
          </MenuItem>
          {Array.from({ length: maxDaysInMonth }, (_, i) => i + 1).map((date) => (
            <MenuItem key={date} value={date} disabled={!isDateValid(date, month, year)}>
              <p className="text-14 text-[#424243] font-medium">{date}</p>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ minWidth: 110, height: 52, marginRight: isMobileDevice() ? "10px" : "35px" }}>
        <Select
          value={month}
          onChange={handleMonthChange}
          displayEmpty
          className={`${customClass}`}
          disabled = {isCashier}
        >
          <MenuItem value="">
            <p className="text-14 text-[#424243] font-medium">Month</p>
          </MenuItem>
          {monthNames.map((monthVal, index) => (
            <MenuItem key={index + 1} value={index + 1} disabled={!isDateValid(date, index+1, year)}>
              <p className="text-14 text-[#424243] font-medium">{monthVal.label}</p>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl sx={{ minWidth: 110, height: 52 }}>
        <Select
          value={year}
          onChange={handleYearChange}
          displayEmpty
          className={`${customClass}`}
          disabled = {isCashier}
          // inputProps={{ 'aria-label': 'Without label' }}
        >
          <MenuItem value="">
            <p className="text-14 text-[#424243] font-medium">Year</p>
          </MenuItem>
          {Array.from(
            { length: currentYear - startYear + 1 },
            (_, i) => startYear + i
          ).map((year) => (
            <MenuItem key={year} value={year} disabled={!isDateValid(date, month, year)}>
              <p className="text-14 text-[#424243] font-medium">{year}</p>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default DateDropdown;